var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notic-bar"},[_c('div',{staticClass:"notice-bar-container"},[_c('div',{staticClass:"notice-bar__wrap"},_vm._l((_vm.message),function(item,index){return _c('div',{key:index,staticClass:"notice-bar__wrap_text"},[_vm._v(" "+_vm._s(item)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }